import { defineMessages } from "react-intl";

const messages = defineMessages({
  // Dialog chrome
  title: {
    id: "Patient.MergePatients.title",
    defaultMessage: "Merge Patients",
  },
  subtitle: {
    id: "Patient.MergePatients.subtitle",
    defaultMessage:
      "Select two or more patients then choose which values to retain for each field",
  },
  addAnotherPatient: {
    id: "Patient.MergePatients.addAnotherPatient",
    defaultMessage: "Add another patient",
  },
  cancel: {
    id: "Patient.MergePatients.cancel",
    defaultMessage: "Cancel",
  },
  merge: {
    id: "Patient.MergePatients.merge",
    defaultMessage: "Merge",
  },
  warningTitle: {
    id: "Patient.MergePatients.warningTitle",
    defaultMessage:
      "This merge will modify multiple records and cannot be undone",
  },
  warningDescription: {
    id: "Patient.MergePatients.warningDescription",
    defaultMessage:
      "The contact details of some of the selected patients will change.",
  },
  processing: {
    id: "Patient.MergePatients.processing",
    defaultMessage:
      "The merge is being processed. Please be patient, this may take up to two minutes.",
  },
  mergedSuccess: {
    id: "Patient.MergePatients.mergedSuccess",
    defaultMessage: "Patient {name} has been merged successfully",
  },
  viewPatient: {
    id: "Patient.MergePatients.viewPatient",
    defaultMessage: "View patient",
  },

  // Search
  searchLabel: {
    id: "Patient.MergePatients.searchLabel",
    defaultMessage: "Add patient to merge",
  },
  searchMinChars: {
    id: "Patient.MergePatients.searchMinChars",
    defaultMessage: "Type at least 3 characters to search",
  },
  searchNoResults: {
    id: "Patient.MergePatients.searchNoResults",
    defaultMessage: "No patients found",
  },
  searchWardOf: {
    id: "Patient.MergePatients.searchWardOf",
    defaultMessage: "Ward of {name}",
  },
  searchFamilyMemberOf: {
    id: "Patient.MergePatients.searchFamilyMemberOf",
    defaultMessage: "Family member of {name}",
  },

  // Column header
  appointmentCount: {
    id: "Patient.MergePatients.appointmentCount",
    defaultMessage:
      "{count, plural, one {# appointment} other {# appointments}}",
  },
  removePatient: {
    id: "Patient.MergePatients.removePatient",
    defaultMessage: "Remove patient from merge",
  },

  // Field labels
  fieldCustomer: {
    id: "Patient.MergePatients.fieldCustomer",
    defaultMessage: "Customer",
  },
  fieldMrn: {
    id: "Patient.MergePatients.fieldMrn",
    defaultMessage: "MRN",
  },
  fieldFirstName: {
    id: "Patient.MergePatients.fieldFirstName",
    defaultMessage: "First name",
  },
  fieldLastName: {
    id: "Patient.MergePatients.fieldLastName",
    defaultMessage: "Last name",
  },
  fieldDateBirth: {
    id: "Patient.MergePatients.fieldDateBirth",
    defaultMessage: "Date of birth",
  },
  fieldAddress: {
    id: "Patient.MergePatients.fieldAddress",
    defaultMessage: "Address",
  },
  fieldRace: {
    id: "Patient.MergePatients.fieldRace",
    defaultMessage: "Race",
  },
  fieldEthnicity: {
    id: "Patient.MergePatients.fieldEthnicity",
    defaultMessage: "Ethnicity",
  },
  fieldSex: {
    id: "Patient.MergePatients.fieldSex",
    defaultMessage: "Sex",
  },
  noCustomerLinked: {
    id: "Patient.MergePatients.noCustomerLinked",
    defaultMessage: "—",
  },

  // Bottom action bar (AC25-27) — {customerName} is the currently chosen
  // "Customer" field's value; both checkboxes are disabled until a Customer
  // field winner exists.
  isWardOf: {
    id: "Patient.MergePatients.isWardOf",
    defaultMessage: "Is a ward of {customerName}",
  },
  isFamilyMemberOf: {
    id: "Patient.MergePatients.isFamilyMemberOf",
    defaultMessage: "Is a family member of {customerName}",
  },

  // Error messages
  errorCheckoutAppointment: {
    id: "Patient.MergePatients.errorCheckoutAppointment",
    defaultMessage:
      "One or more selected patients have an appointment in checkout status",
  },
  errorConflictingAppointments: {
    id: "Patient.MergePatients.errorConflictingAppointments",
    defaultMessage:
      "One or more selected patients have overlapping future appointments",
  },
  errorRecordLocked: {
    id: "Patient.MergePatients.errorRecordLocked",
    defaultMessage:
      "This action is currently blocked because a merge is in progress.",
  },
  errorPacsMergeFailed: {
    id: "Patient.MergePatients.errorPacsMergeFailed",
    defaultMessage: "Merge for patient {name} failed.",
  },
  errorGeneric: {
    id: "Patient.MergePatients.errorGeneric",
    defaultMessage: "Merge failed. Please try again.",
  },
});

export default messages;
